import { Menu, MenuItem } from '@mui/material';
import React, { useState } from 'react';

import { LOGS_MODE_TARGET_LABEL, LogsMode, PUBLISH_TARGETS } from '@/features/logsMode';

type Props = {
  /** Кнопка-триггер: получает обработчик, открывающий меню */
  children: (open: (e: React.MouseEvent<HTMLElement>) => void) => React.ReactNode;
  onPublish: (target: LogsMode) => unknown;
};

/**
 * Публикация в Трекер или в собственный учёт: пока идёт переход, выбирают вручную.
 * Пока в собственный учёт не пишем, цель одна — публикуем сразу, без меню
 */
export const PublishTargetMenu: React.FC<Props> = ({ children, onPublish }) => {
  const [anchor, setAnchor] = useState<HTMLElement | null>(null);

  const open = (e: React.MouseEvent<HTMLElement>) => {
    e.stopPropagation();

    if (PUBLISH_TARGETS.length === 1) {
      void onPublish(PUBLISH_TARGETS[0]);

      return;
    }

    setAnchor(e.currentTarget);
  };

  return (
    <>
      {children(open)}
      <Menu
        anchorEl={anchor}
        open={!!anchor}
        onClose={() => setAnchor(null)}
        onClick={(e) => e.stopPropagation()}
      >
        {PUBLISH_TARGETS.map((target) => (
          <MenuItem
            key={target}
            onClick={() => {
              setAnchor(null);
              void onPublish(target);
            }}
          >
            {LOGS_MODE_TARGET_LABEL[target]}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};
